import React from 'react';
import { Select } from 'antd';
import { CANONICAL_CA_ZONES } from '../../utils/timezone';

interface TimezoneSelectProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
    value,
    onChange,
    placeholder = 'Select timezone',
    style = { width: '100%' },
    disabled = false,
}) => {
    return (
        <Select
            placeholder={placeholder}
            style={style}
            showSearch
            disabled={disabled}
            value={value}
            onChange={onChange}
            filterOption={(input, option) =>
                // contains, case insensitive
                ((option?.label as string) ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            options={CANONICAL_CA_ZONES.map((tz) => ({
                // use string ('America/Toronto') for both value and label
                value: tz,
                label: tz,
            }))}
        />
    );
};
